<template>
  <div>
    <el-dialog  title="金融授信产品说明" :visible.sync="dialogVisible" width="60%" custom-class="payment_dialog" :before-close="handleClose">
        <div>
            <div class="payment_top">
                <h2>付货款，就找化工宝白条<span>纯信用、循环使用、随借随还、使用便捷</span></h2>
                <p>400-820-6662</p>
            </div>
            <div class="payment_content">
                <h4>产品介绍</h4>
                <div><p>最高借款：<span>100万</span></p><p>融资费率：<span>7%年化率+1%平台服务费</span></p><p>融资期限：<span>60天</span></p></div>
                <p style="margin:5px 0;">融资要求：在平台活跃年限大于1年、无不良平台交易记录(具体以数据实验室风控评审结果为准)</p>
                <p>授信材料：法人在线操作，递交企业营业执照、法人身份证、企业和个人信息查询使用授权书即可</p>
            </div>
            <div class="payment_pic">
                <!-- <img src="../../assets/img/ksxcx.jpg" alt=""> -->
                <img src="https://test.b-chem.com/static/finance-module/img/ewm.999be5f4.jpg" alt="">
                <span>微信扫一扫，直接手机端操作</span>
            </div>
        </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
    props: {
        // 弹框是否打开
        isDialog: {
            type: Boolean,
            default: false,
        },

    },
    watch:{
        isDialog:{ 
            handler(newV, oldV) {
                this.getWhiteSign()
                // this.dialogVisible= true 
            },
        },
    },
    data() {
      return {
        dialogVisible: false,

      };
    },
    methods:{
        getWhiteSign(){
            const loading = this.$loading({
                //lock的修改符--默认是false
                lock: true,
                //显示在加载图标下方的加载文案
                text: "数据加载中",
                //自定义加载图标类名(在elementUI 文档查找)
                spinner: "el-icon-loading",
                //(可以自己定义)遮罩层颜色
                background: "rgba(255, 255, 255, .7)",
                //loadin覆盖的dom元素节点(整个页面的话'#body' 表格的话'#table'等等 )
                target: document.querySelector("#loadingBox1111"),
            });
            let formData = new FormData();
            formData.append("companyCode", JSON.parse(localStorage.getItem('companyInfo')).bspCompanyCode);
            this.$api.twice.postQueryCreditBaseInfo(formData).then(res=>{
            // this.$api.twice.getQueryCreditAccount().then(res=>{
            //   console.log(res);
              loading.close();
              if(res.code=='200'){
                if(res.data.status=='00'||!res.data.status){
                    this.dialogVisible= true 
                }else{
                    window.open('https://test.b-chem.com/static/finance-module/#/')
                }
              }else{
                this.$message.error(res.message)
              }
            })
        },
        handleClose(){
          this.dialogVisible = false
        },

    },
};
</script>

<style scoped>
::v-deep .payment_dialog{
    border-radius: 10px;
}
::v-deep .payment_dialog .el-dialog__body{
    padding-top: 10px;
     box-sizing: border-box;
}
.payment_top{
    background: url('http://ax.b-chem.cn/pro/3NYe7R7ZeBM/images/%E7%A2%B3%E4%B8%9A%E5%AE%A2%E5%95%86%E6%9C%8D%E5%8A%A1pc%E7%AB%AF/u30.png') no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 20px 30px 5px 120px;
    box-sizing: border-box;
}
.payment_top h2{
    font-size: 24px;
    font-weight: bold;
}
.payment_top h2 span{
    font-size: 14px;
    font-weight: normal;
    margin-left: 30px;
}
.payment_top p{
    font-size: 18px;
    font-style: italic;
}
.payment_content{
    padding: 20px;
    box-sizing: border-box;
}
.payment_content h4{
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
}
.payment_content h4 span{
    font-size: 16px;
    font-weight: normal;
    margin-bottom: 10px;
    margin-left: 30px;
}
.payment_content div{
    display: flex;
}
.payment_content div p{
    margin-right: 40px;
}
.payment_content div p span{
    font-weight: bold;
}
.payment_content1 p{
    font-size: 16px;
}
.payment_pic{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
}
.payment_pic img{
    width: 250px;
    height: 250px;
    display: block;
    margin-bottom: 20px;
}

</style>
